function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  d: "M0 0v16h16V0H0zm13.292 3.79l-.858.824a.25.25 0 00-.095.24V10.9a.25.25 0 00.095.241l.838.823v.18H9.057v-.18l.868-.843c.086-.085.086-.11.086-.24V5.992l-2.414 6.13H7.27l-2.81-6.13v4.109a.567.567 0 00.155.471l1.13 1.37v.18H2.543v-.18l1.129-1.37c.12-.125.174-.3.145-.471V5.35A.416.416 0 003.683 5L2.679 3.79v-.18h3.116l2.409 5.283 2.118-5.283h2.97v.18z",
  id: "medium_svg__a"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "medium_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#medium_svg__a"
})), React.createElement("use", {
  fill: "currentColor",
  fillRule: "nonzero",
  xlinkHref: "#medium_svg__a"
}), React.createElement("g", {
  mask: "url(#medium_svg__b)",
  fill: "currentColor"
}, React.createElement("path", {
  d: "M0 0h20v20H0z"
})));

var Medium = function Medium(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
};

export default Medium;